import React from 'react';
import { Text, Box, Skeleton, Contrast } from '@landr/maestro';
import { MetasPopover } from 'components/MetasPopover/MetasPopover';
import { getMetasDisplayName } from 'helpers/getMetasDisplayName/getMetasDisplayName';
import useGetCurrentBreakpoint from 'hooks/useGetCurrentBreakpoint/useGetCurrentBreakpoint';
import { BaseMeta } from 'types';
import * as Styled from './styled';

const metasToDisplay: { [key: string]: number } = {
    sm: 1,
    md: 3,
    lg: 2,
    xl: 3,
    default: 4,
};

const useMetasText = ({ metas }: { metas: BaseMeta[]; isFree: boolean }) => {
    const currentBreakpoint = useGetCurrentBreakpoint();

    const maxVisible =
        metasToDisplay[currentBreakpoint] ?? metasToDisplay.default;

    const metasDisplayName = getMetasDisplayName(metas);

    const result = {
        visible: metasDisplayName.slice(0, maxVisible),
        extra: metasDisplayName.slice(maxVisible),
    };

    return result;
};

export const MetasText = ({
    metas = [],
    showExtra = true,
    isLoading = false,
    isFree = false,
    size = 'sm',
    contrast = 'low',
}: {
    metas?: BaseMeta[];
    showExtra?: boolean;
    isLoading?: boolean;
    isFree?: boolean;
    size?: 'xs' | 'sm';
    contrast?: Contrast;
}) => {
    const { visible, extra } = useMetasText({ metas, isFree });

    if (isLoading) {
        return (
            <Box mt="5px">
                <Skeleton width="36px" height="14px" />
            </Box>
        );
    }

    return (
        <Styled.Wrapper>
            {visible?.map((meta: string) => (
                <Text key={meta} size={size} contrast={contrast}>
                    {meta}
                </Text>
            ))}
            {extra && showExtra && (
                <MetasPopover metas={extra} size={size} contrast={contrast} />
            )}
        </Styled.Wrapper>
    );
};
